import {isBiologicsOwnedItem, StandardFeatureItemState} from 'auth/capabilities/getCapabilityFeatures';
import {isInRegistry} from 'folder-items/FileUtil';
import type {ListableItem} from 'search/SearchConstants';

// Shared derive helper for search/listing payloads (sidepanel rows, expanded tables, listing open).
// Other contexts (file menu parent-folder semantics, chips, editor toolbars) should assemble itemState
// locally when their semantics differ. See StandardFeatureItemState in getCapabilityFeatures.ts for the
// derive / gate / enforce layering.
export function standardFeatureItemStateFromListableItem(item: ListableItem): StandardFeatureItemState {
  return {
    isRegistered: isInRegistry(item),
    isBiologicsOwned: isBiologicsOwnedItem(item),
  };
}
